import { useContext, useEffect } from 'react'
import './Brands.sass'
import BrandsManager from './BrandsManager'
import { withRouter } from 'react-router-dom'
import BrandsPanel from './BrandsPanel/BrandsPanel'
import { AuthContext } from '../../../../App'

function Brands({ ...router }) {
  const { setPageTitle } = useContext(AuthContext)
  useEffect(() => setPageTitle('Бренди'))

  return (
    <div className="Brands">
      <BrandsPanel onClickPath={'/products/brands'} routerIdName="brandId" canReorder />
      <BrandsManager />
    </div>
  )
}

export default withRouter(Brands)
